import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  fullWidth?: boolean;
  size?: 'md' | 'lg' | 'xl';
}
export function Button({
  children,
  fullWidth = false,
  size = 'lg',
  className = '',
  ...props
}: ButtonProps) {
  const sizeClasses = {
    md: 'py-3 px-6 text-base',
    lg: 'py-4 px-8 text-lg md:text-xl',
    xl: 'py-5 px-10 text-xl md:text-2xl font-bold'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        bg-gradient-to-r from-gold-500 to-gold-400 hover:from-gold-400 hover:to-gold-500
        text-navy-900 font-heading font-bold rounded-xl shadow-[0_0_20px_rgba(212,168,67,0.3)]
        hover:shadow-[0_0_30px_rgba(212,168,67,0.5)] transition-all duration-300
        ${sizeClasses[size]}
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} {...props} data-id="element-42">
      {children}
    </motion.button>;
}